import { TableCell, TableRow } from '@mui/material'
import styles from './methodPayment.module.scss'
import Skeleton from '@mui/material/Skeleton'

export const LoadingSkeleton = () => {
  return (
    <TableRow className={styles.tableRow}>
      <TableCell className={styles.tableCell}>
        <Skeleton />
      </TableCell>
      <TableCell className={styles.tableCell}>
        <Skeleton />
      </TableCell>
      <TableCell className={styles.tableCell}>
        <Skeleton />
      </TableCell>
      <TableCell className={styles.tableCell}>
        <Skeleton />
      </TableCell>
    </TableRow>
  )
}